import(/* webpackMode: "eager" */ "/var/www/msa-admin-dashboard/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/msa-admin-dashboard/src/component/Shared/DisabledZoom/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/msa-admin-dashboard/src/component/Shared/MetaPixels/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/msa-admin-dashboard/src/component/Shared/NProgressHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/msa-admin-dashboard/src/component/Shared/Wrapper/index.tsx");
